// Where tapping a banner takes the customer. Keep in sync with
// backend/utils/bannerRedirects.js and the customer app (home_screen.dart).
export const NO_REDIRECT = 'none';

export const BANNER_REDIRECTS = [
  { value: 'STORE_250', label: '250 Store' },
  { value: 'STORE_99', label: '99 Store' },
  { value: 'STORE_DISCOUNT', label: 'Discount Store' }
];

export const bannerRedirectLabel = (value) =>
  BANNER_REDIRECTS.find((r) => r.value === value)?.label || null;
